import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { clearMovexOverviewPaginationStorage } from '@/utils/movexOverviewPaginationStorage';

const AUTH_STORAGE_NAME = 'movex-auth';

export const useAuth = create(
  persist(
    set => ({
      accessToken: '',
      refreshToken: '',
      user: null, // { id, firstName, lastName, permissions: [{ id, action, subject }], ... }
      hasHydrated: false,
      setHasHydrated: hasHydrated => set({ hasHydrated }),

      setAccessToken: accessToken => set({ accessToken }),

      setRefreshToken: refreshToken => set({ refreshToken }),

      setUser: user => set({ user: user ?? null }),

      setTokens: ({ accessToken, refreshToken }) =>
        set({
          accessToken: accessToken || '',
          refreshToken: refreshToken || '',
        }),

      clearAuth: () => {
        try {
          localStorage.removeItem('user-info');
          clearMovexOverviewPaginationStorage();
        } catch (error) {
          console.error('Error resetting user type:', error);
        }

        return set({
          accessToken: '',
          refreshToken: '',
          user: null,
        });
      },

      getUserId: () => {
        const state = useAuth.getState();
        if (state.user?.id !== undefined && state.user?.id !== null) {
          return state.user.id;
        }
        try {
          const staffInfo = JSON.parse(localStorage.getItem('user-info'));
          return staffInfo?.id ?? null;
        } catch (_) {
          return null;
        }
      },
      // Legacy methods (for backward compatibility)
      addUserData: token => set({ accessToken: token }),
      removeUserEmail: () => set({ accessToken: '' }),
      addUserNewEmail: email => set({ email: email.toLowerCase() }),
      removeNewEmail: () => set({ email: '' }),
    }),
    {
      name: AUTH_STORAGE_NAME, // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      onRehydrateStorage: () => state => {
        state?.setHasHydrated?.(true);
      },
    }
  )
);
